export const KycAdminPaths = {
  //search
  searchByBankAccountNumber: "bank-account-number",
  searchByRegisteredMobileNo: "registered-mobile-number",
  displayWall: "display-wall",
  searchByAadharNo: "aadhar-number",
  searchByPanNo: "pan-number",
  stateWiseSearchAbName: "state-wise-search-ab-name",
  referenceNumber: "reference-number",
  searchByEmailId: "email-id",
  mobileDeclaration: "mobile-declaration",
  infoUpdate: "info-update",
  mobileHistory: "mobile-history",
  nameHistory: "name-history",
  rbRepurchase: "rb-repurchase",
  nbRepurchase: "nb-repurchase",
  inactiveRegisteredBuyer: "inactive-registered-buyers",

  // delete
  deleteBankAccountDetails: "ab-bank-account-details",
  deletePanNumber: "ab-pan",
  enableReKYC: "ab-enable-re-kyc",
  bankAccount:'bank-account',
  bulkBankAccountEnable:'bank-account/bulk-enable',
  panNo:'pan-no',
  bulkPanNumberEnable:'pan-no/bulk-enable',

  // disable
  disableBankNo: "ab-bank-no",
  disablePanNo: "ab-pan-no",

  // report
  declareReport: "kyc-declare-report",
  kycDetailReport: "kyc-detail-report",
  kycNotOk: "kyc-not-ok-report",
  currentBusiness: "current-business",
  kycFeedingReport: "kyc-feeding-report",
  diamondClubReport: "diamond-club-report",
  selfPVReport: "self-pv-report",
  diamondClubPurchaseReport: "diamond-club-purchase-report",
  executiveFeedback_Report: "executive-feedback-report",
  executiveFeedback_ReportData: "executive-feedback-report-data",
  executiveFeedback_UserProfile: "executive-feedback-user-profile",
  nonPurchasingABReport: "non-purchasing-ab-report",
  amountWiseABCountReport: "amount-wise-ab-count-report",
  abLastSixMonthsPurchaseReport: "ab-last-six-months-purchase-report",
  pinAchieverReport: "pin-achiever-report",
  pinDashboard: "pin-dashboard",
  stopTerminationReport: "stop-termination-report",
  redKycs:'red-kycs',
  abBulkDetailsReport: 'ab-bulk-details-report',
  pinGrowthAnalysis: "pin-growth-analysis",
  abCommission: "ab_commission",

  // mis
  notOkReport: "not-ok-report",
  executivePerformanceReport: "executive-performance-report",
  executiveCheckReport: "executive-check-report",
  declarationCheckReport:"declaration-check-report",
  bankAndPanReport:"bank-pan-report",
  emailCheckReport:"email-check-report",
  mobileCheckReport:"mobile-check-report",
  idProofCheckReport:"id-proof-check-report",
  nameUpdateCheckReport:"name-update-check-report",
  infoUpdateCheckReport:"info-update-check-report",
  dailyUpdateSummaryReport: "daily-update-summary-report",

  // admin reports
  deathCaseReport: "death-case-report",
  stopABReport: "stopped-ab-report",
  allTermination: "all-termination-report",

  // associate buyers
  abIdStop: "ab-id-stop",
  resetpswrd: "reset-passsword",
  stopPayment: "ab-stop-payment",
  abDetails: "ab-details",
  abBankAccntUpdate: "ab-bank-account-update",

  // rePurchase: "re-purchase",
  abNotPurchaseOtp: "ab-not-purchase-otp",
  checkMonthlyMeeting: "ab-check-monthly-meeting",
  rePurchase: "ab-re-purchase-summary-and-detail",
  smsDiamondClub: "sms-diamond-club",
  abNameUpdate: "ab-name-update",
  updateMobileCount: "update-mobile-count",

  // lists
  eKyc: "e-kyc",
  monthlyMeetings: "monthly-meetings",
  terminateRepurchaseReport: "terminate-repurchase-report",
  abUptree: "ab-uptree",
  checkMonthlyMeetings: "check-monthly-meetings",
  abPurchaseDownload: "ab-purchase-download",
  technicalCore: "technical-core",
  technicalLeaderTreeView: "technical-leader-tree-view",

  // KYC
  kycSimilarEntities: "kyc-similar-entities",
  kycMatchingEntities: "kyc-matching-entities",
  kycDocumentUpdate: "kyc-document-update",
  abPhotoUpdate: "ab-photo-update",
  kycNewEntry: "kyc-new-entry",
  kycOldEntry: "kyc-old-entry",
  kycVerification: "kyc-verification",
  kycInstantApproval: "kyc-instant-approval",

  // Terminate
  terminateOk: "terminate-ok",
  terminateAB: "terminate-ab",
  softTerminate: "executive-feedbacks",

  // document update
  addPan: "ab-pan-add",
  address_id_proof_update: "address-&-id-proof-update",

  // update request
  bankUpdateRequest: "bank-update-request",
  viewBankUpdateRequest: "bank-update-request/view-request",
  panUpdateRequest: "pan-update-request",
  viewPanUpdateRequest: "pan-update-request/view-request",
  mobileUpdateRequest: "mobile-update-request",
  viewMobileUpdateRequest: "mobile-update-request/view-request",

  // misc
  abIdUnStop: "ab-id-unstop",
  deathCase: "death-case",
  assignKYCLead: "assign-kyc-leads",

  //kyc admin
  gst:"gst",
  updateGst:"gst/update-gst",
  abUnstop:'ab-unstop',
  kycReportsViewLogs: 'kyc-reports-view-logs',
  increaseMobileCount: 'increase-mobile-count',
  exceptionalCases: 'exceptional-cases',
  masterPinDescription: 'master-pin-description',
  masterDocuments: 'master-documents',
  masterOccupations: 'master-occupations',
  masterRelations: 'master-relations',
  masterDiamondClub: 'master-diamond-club',
  masterCompanyList: 'master-company-list',
  masterKycReasonDesc: 'master-kyc-reason-desc',
  masterDepartmentList: 'master-department-list',

  //maintenance screen
  kycMaintenance:'kyc-maintenance',

  //master ab detail
  masterAbDetails:'master-ab-details',
  imageHistory: 'image-history',
  kycAccountsBusinessPayment: "business-entry",
  kycAccountsPayment: "payment-entry",
  kycAccountsJv: "jv-entry",
  unethicalJoiningStop: "unethical-joining-stop",
  unethicalJoiningStopListing: "unethical-joining-stop/listing"
};
